import { ThreeStars, Controller, RedCross, IndustrialPlant } from './icons';

export const typeFilters = {
  'tien-ich': [
    {
      id: 'landmark',
      icon: ThreeStars,
      label: 'location',
    },
    { id: 'golf-club', icon: Controller, label: 'golf_course' },
    { id: 'hospital', icon: RedCross, label: 'hospital' },

    { id: 'airport', icon: IndustrialPlant, label: 'airport' },
  ],
  'giao-thong': [
    {
      id: 'main-road',
      icon: ThreeStars,
      label: 'main_road',
    },
    {
      id: 'secondary-road',
      icon: ThreeStars,
      label: 'city_road',
    },
    { id: 'small-road', icon: ThreeStars, label: 'small_road' },
    // { id: 'duong-song', icon: ThreeStars, label: 'Đường sông' },
  ],
};

export const types = [
  {
    id: 'tien-ich',
    label: 'all_amenities',
    labelShort: 'Tiện ích',
  },
  {
    id: 'giao-thong',
    label: 'all_traffic',
    labelShort: 'Giao thông',
  },
];
